export default __webpack_public_path__ + "static/media/white-hands-holding-earth.b78e6fcd.png";